import Box from '@mui/material/Box';

import StyledStack from '@webclient/components/pages/home/sections/bots/header/styles';

import { Text } from '@knowz/knowz-ui';

type Props = {
  title: string;
  subtitle: string;
  PrimaryAction: React.ReactNode;
  SecondaryAction: React.ReactNode;
};

export default function Header({
  PrimaryAction,
  SecondaryAction,
  subtitle,
  title,
}: Props) {
  return (
    <StyledStack>
      <Box sx={{ flex: 1 }}>
        <Text
          variant="textLg"
          weight="semibold"
        >
          {title}
        </Text>
        <Text
          variant="textSm"
          color="text.secondary"
        >
          {subtitle}
        </Text>
      </Box>
      {PrimaryAction}
      {SecondaryAction}
    </StyledStack>
  );
}
